import { gql } from "@apollo/client";


//This will excecute at the time of Save button click
// export const STRIVE_ESCROW_TRACKING = gql`
// mutation updateEscrowTracking(
//     $values: JSON!
// ) {
//     updateEscrowTracking(input: {
//         values: $values
//     }) {
//         escrowTracking {
//             additional_earnest_money_received: 
//             additional_earnest_money_received_checkbox: 
//             arcimedes_created: 
//             arcimedes_created_by: 
//             arcimedes_modified: 
//             arcimedes_modified_by: 
//             arcimedes_row_id: 
//             buyers_title_objections_due: 
//             buyers_title_objections_due_checkbox: 
//             closing_date: 
//             closing_date_checkbox: 
//             closing_extension: 
//             closing_period: 
//             dd_site_created__access_granted: 
//             dd_site_created__access_granted_checkbox: 
//             deleted: 
//             earnest_money_received: 
//             earnest_money_received_checkbox: 
//             effective_date: 
//             effective_date_checkbox: 
//             escrow_officer: 
//             estoppelssnda_requested_from_lender_buyer_or_tenant: 
//             estoppelssnda_requested_from_lender_buyer_or_tenant_checkbox: 
//             estoppelssdna_due: 
//             estoppelssdna_due_checkbox: 
//             feasibility_extension: 
//             feasibility_period: 
//             feasibility_period_expires__deposit_nonrefundable: 
//             feasibility_period_expires__deposit_nonrefundable_checkbox: 
//             financing_application_deadline: 
//             financing_application_deadline_checkbox: 
//             financing_approval: 
//             financing_approval_checkbox: 
//             financing_period_ends: 
//             financing_period_ends_checkbox: 
//             has_title_approved_survey: 
//             have_all_due_diligence_materials: 
//             property_id: 
//             psa_sent_to_buyer: 
//             psa_sent_to_buyer_checkbox: 
//             psa_sent_to_title: 
//             psa_sent_to_title_checkbox: 
//             receipted_psa_received__sent_to_buyers_agent: 
//             receipted_psa_received__sent_to_buyers_agent_checkbox: 
//             received_title_commitment: 
//             received_title_commitment_checkbox: 
//             rofr_notice_sent_to_tenant: 
//             rofr_notice_sent_to_tenant_checkbox: 
//             rofr_waiver_sent_to_buyerside__title_co: 
//             rofr_waiver_sent_to_buyerside__title_co_checkbox: 
//             seller_response_to_buyer_objections: 
//             seller_response_to_buyer_objections_checkbox: 
//             send_title_invoice_wire_cam_deposits_prorations: 
//             send_title_invoice_wire_cam_deposits_prorations_checkbox: 
//             survey_ordered: 
//             survey_ordered_checkbox: 
//             survey_sent_to_title: 
//             survey_sent_to_title_checkbox: 
//             task: 
//             title_company: 
//             title_objection_period: 
//             title_objection_period_checkbox: 
//             title_sent_out_closing_statements_for_review: 
//             title_sent_out_closing_statements_for_review_checkbox: 
//             updated_db__istrive: 
//             updated_to_uc_on_externals: 
//             update_insurance_certificates: 
//             update_insurance_certificates_checkbox: 
//             verify_close_10_days_before_closing: 
//             verify_close_10_days_before_closing_checkbox: 
//             wiring_instructions_sent_to_buyeragent: 

//         }
//     }
// }
// `
export const STRIVE_ESCROW_TRACKING_UPDATE = gql`
mutation CreateOrUpdateStriveEscrowTracking($input: [StriveEscrowTrackingInput]) {
  createOrUpdateStriveEscrowTracking(input: $input) {
    success
    message
    data {
      arcimedes_row_id
      property_id
      deleted
      task
      title_company
      escrow_officer
      psa_sent_to_buyer
      psa_sent_to_buyer_checkbox
      have_all_due_diligence_materials
      effective_date
      effective_date_checkbox
      rofr_notice_sent_to_tenant
      rofr_notice_sent_to_tenant_checkbox
      rofr_waiver_sent_to_buyerside__title_co
      rofr_waiver_sent_to_buyerside__title_co_checkbox
      psa_sent_to_title
      psa_sent_to_title_checkbox
      survey_sent_to_title
      survey_sent_to_title_checkbox
      receipted_psa_received__sent_to_buyers_agent
      receipted_psa_received__sent_to_buyers_agent_checkbox
      dd_site_created__access_granted
      dd_site_created__access_granted_checkbox
      updated_db__istrive
      updated_to_uc_on_externals
      wiring_instructions_sent_to_buyeragent
      earnest_money_received
      earnest_money_received_checkbox
      has_title_approved_survey
      survey_ordered
      survey_ordered_checkbox
      received_title_commitment
      received_title_commitment_checkbox
      buyers_title_objections_due
      buyers_title_objections_due_checkbox
      seller_response_to_buyer_objections
      seller_response_to_buyer_objections_checkbox
      title_objection_period
      title_objection_period_checkbox
      financing_application_deadline
      financing_application_deadline_checkbox
      feasibility_period
      feasibility_extension
      feasibility_period_expires__deposit_nonrefundable
      feasibility_period_expires__deposit_nonrefundable_checkbox
      financing_approval
      financing_approval_checkbox
      financing_period_ends
      financing_period_ends_checkbox
      additional_earnest_money_received
      additional_earnest_money_received_checkbox
      estoppelsnda_requested_from_lender_buyer_or_tenant
      estoppelsnda_requested_from_lender_buyer_or_tenant_checkbox
      estoppelssdna_due
      estoppelssdna_due_checkbox
      verify_close_10_days_before_closing
      verify_close_10_days_before_closing_checkbox
      send_title_invoice_wire_cam_deposits_prorations
      send_title_invoice_wire_cam_deposits_prorations_checkbox
      update_insurance_certificates
      update_insurance_certificates_checkbox
      title_sent_out_closing_statements_for_review
      title_sent_out_closing_statements_for_review_checkbox
      closing_period
      closing_extension
      closing_date
      closing_date_checkbox
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
    }
    error
  }
}
  `